import {Storages} from "../../../controllers/Storages";
import {GetStorage} from "../../../../cuppa/reactComponents/GetStorage";
import {useState} from "react";
import "../../../../cuppa/components/cuppa.menu";
import {CuppaMenu} from "../../../../cuppa/components/cuppa.menu";
import {cuppa, log} from "../../../../cuppa/cuppa";
import {UserCtrl} from "../../../controllers/UserCtrl";
import {Language} from "../../../controllers/Language";
import {Utils} from "../../../controllers/Utils";
import {Constants} from "../../../controllers/Constants";

export function UserInfo({}){
	const [user, setUser] = useState();
	
	return (
		<>
			<div
				className={'flex d-row j-center a-center btn-alpha user-info m-r-0-s1100'}
				style={{background:'var(--bg-1)', padding:'0 2rem',  alignSelf:'stretch', borderWidth:'0 1px 0 1px', borderColor:'#eee', borderStyle:'solid', marginRight:20 }}
			>
				<GetStorage {...Storages.user} callback={setUser} />
				<div className={'image'} style={{width:32, height:32, borderRadius:32, marginRight:10, backgroundImage:`url('${user?.photo ?? require('../../../media/images/profile.png')}')`}}></div>
				<div className={'d-none-s1100'}>
					<div>{user?.name || ''} {user?.last_name || ''}</div>
					<div>
						<span className={'f-12 o-75'}>{UserCtrl.getRole({user}).role || ''}</span>
						{UserCtrl.isSuperUser() && <span className={'tag bg-progress f-10'} style={{margin:'0 3px'}} title={Language.value('Super User')}>{Language.value('SU')}</span>}
					</div>
				</div>
			</div>
			<cuppa-menu
				class={"dropdown ani-fade-up"}
				target={'.user-info'}
				pos-x={CuppaMenu.POSITION.RIGHT_IN}
				pos-y={CuppaMenu.POSITION.BOTTOM}
				style={{width:200, marginTop:2}}
				contextual-menu={true}
			>
				<button
					className={'dropdown-button'}
					onClick={()=>{
						Utils.redirect(`/users/user/?profile=${cuppa.base64Encode(UserCtrl.getUser().id)}`, {reload:true, forcePath:true})
					}}
				>
					<i className="fa fa-user" aria-hidden="true"></i>
					<span>{Language.value("My Profile")}</span>
				</button>
				<button className={'dropdown-button'} onClick={UserCtrl.logOut}>
					<i className="fa fa-sign-out" aria-hidden="true"></i>
					<span>{Language.value('Log out')}</span>
				</button>
			</cuppa-menu>
		</>
	)
}
